import error404 from './404.svg';
import error500 from './500.svg';

export {
    error404, error500
}